import React from "react";
import { LinkSimple } from "@phosphor-icons/react";

// Optional rule, open to everyone (Jack, 2026-10-29; tester-only since
// 2026-10-14): a win needs one unbroken chain of your tiles into the other
// base. A tappable card with an on/off pill, styled like the game's pickers.
export default function UnbrokenChainToggle(props) {
  return (
    <RuleToggle {...props} Icon={LinkSimple} title="Unbroken chain"
      text="To win, your tiles must form one unbroken chain into the other base." />
  );
}

// The card itself, shared with the other optional rules (SameTilesToggle).
export function RuleToggle({ checked, onChange, className = "", testId, Icon, title, text }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      data-testid={testId}
      className={`w-full flex items-center gap-3 rounded-xl border p-2.5 text-left transition-colors ${
        checked ? "border-brand bg-brand/10" : "border-border bg-background hover:border-brand/60"
      } ${className}`}
    >
      <span className={`flex-none grid place-items-center w-9 h-9 rounded-lg transition-colors ${
        checked ? "bg-brand text-brand-foreground" : "bg-muted text-muted-foreground"
      }`}>
        <Icon size={20} weight="bold" />
      </span>
      <span className="min-w-0 flex-1">
        <span className={`block text-sm font-bold ${checked ? "text-brand" : "text-foreground"}`}>{title}</span>
        <span className="block text-[11px] leading-snug text-muted-foreground">{text}</span>
      </span>
      <span className={`flex-none relative w-10 h-6 rounded-full transition-colors ${checked ? "bg-brand" : "bg-muted-foreground/30"}`}>
        <span className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${checked ? "translate-x-4" : ""}`} />
      </span>
    </button>
  );
}
